import React from 'react';
import moment from 'moment';
import { isEmpty, uniqueId } from 'lodash';
import { connect } from 'react-redux';
import DateFormat from 'constants/date_format';
import Section, { SectionHeader } from './Section';

// Predicates
const byDateAscending = (a, b) => moment(a.date).diff(moment(b.date));
const hasDate = ({ date }) => !isEmpty(date);

const renderDateInfo = blocks =>
  blocks.map(({ label, date, user }, i, { length }) => (
    <div className={i === length - 1 ? '' : 'mb-16'} key={uniqueId()}>
      <SectionHeader>{label}</SectionHeader>
      <div className="c-brand-gray-darker">
        {moment(date).format(DateFormat.LONG_AT_TIME)}
      </div>
      <div className="c-brand-gray-darker">
        {t('common.by')} {user || t('common.deleted_user')}
      </div>
    </div>
  ));

const HistoryInfo = ({
  createdAt,
  updatedAt,
  publishedAt,
  archivedAt,
  isNewPath,
}) => {
  if (isNewPath) return false;
  const dates = [
    { label: 'Archived', ...archivedAt },
    { label: 'Last Updated', ...updatedAt },
    { label: 'Published', ...publishedAt },
    { label: 'Created', ...createdAt },
  ];
  return (
    <Section>
      {renderDateInfo(dates.filter(hasDate).sort(byDateAscending))}
    </Section>
  );
};

const mapStateToProps = ({ pathBuilder }) => ({
  isNewPath: !pathBuilder.id,
  updatedAt: pathBuilder.updatedAt,
  createdAt: pathBuilder.createdAt,
  publishedAt: pathBuilder.publishedAt,
  archivedAt: pathBuilder.archivedAt,
});

export default connect(mapStateToProps)(HistoryInfo);
